import React from 'react';

const ReturnPage = () => {
  return (
    <div className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow-md h-full">
      <h1 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Add Product</h1>
      <p>Manage roles, permissions, and access here.</p>
    </div>
  );
};

export default ReturnPage;   
